export default "__VITE_ASSET__d25beba0__"